// Angular
import {
  Component,
  EventEmitter,
  inject,
  OnInit,
  Output,
  signal,
  ViewChild,
} from '@angular/core';
import { NgClass } from '@angular/common';
// PrimeNG
import { SkeletonModule } from 'primeng/skeleton';
// Components
import { StoreListSidebarComponent } from '../store-list-sidebar/store-list-sidebar.component';
// Environment
import { environment } from '@env/environment';
// Services
import { GeolocationServiceV2 } from '@core/services-v2/geolocation/geolocation.service';
// Models
import { Store } from '@core/services-v2/geolocation/models/store.interface';
import { CheckoutStorageService } from 'src/app/checkout-v2/services/checkout-storage/checkout-storage.service';

const NG_MODULES = [NgClass];
const PRIME_MODULES = [SkeletonModule];
const COMPONENTS = [StoreListSidebarComponent];

@Component({
  selector: 'app-pickup-store-form',
  standalone: true,
  imports: [NG_MODULES, PRIME_MODULES, COMPONENTS],
  templateUrl: './pickup-store-form.component.html',
})
export class PickupStoreFormComponent implements OnInit {
  //#region ViewChild components
  @ViewChild('sidebar') sidebar!: StoreListSidebarComponent;
  //#endregion

  //#region Inputs & Outputs
  @Output() onChange: EventEmitter<Store> = new EventEmitter();
  //#endregion

  countryCode = environment.country;
  stores = signal<Store[]>([]);
  selectedStore = signal<Store | null>(null);
  isLoadingStores = signal<boolean>(true);

  //#region Dependencies
  private readonly geolocationService = inject(GeolocationServiceV2);
  private readonly checkoutStorageService = inject(CheckoutStorageService);
  //#endregion

  //#region Lifecycle Hooks
  ngOnInit(): void {
    this.loadStores();
  }
  //#endregion

  /**
   * Al seleccionar una tienda desde el sidebar.
   * @param selectedStore - Tienda seleccionada.
   */
  onSelectStore(selectedStore: Store): void {
    this.selectedStore.set(selectedStore);
    this.onChange.emit(selectedStore);
  }

  private loadStores(): void {
    const storedCheckoutStore = this.checkoutStorageService.getPickupStore();
    this.isLoadingStores.set(true);

    this.geolocationService.stores$.subscribe({
      next: (stores) => {
        let selectedStoreDetail: Store | null = null;

        if (storedCheckoutStore) {
          selectedStoreDetail =
            stores.find((store) => store.code === storedCheckoutStore.code) ||
            null;
        } else {
          const selectedStore = this.geolocationService.getSelectedStore();
          selectedStoreDetail =
            stores.find((store) => store.code === selectedStore.code) || null;
        }

        if (!selectedStoreDetail) return;
        this.selectedStore.set(selectedStoreDetail);
        this.onChange.emit(selectedStoreDetail);
        const filteredStores = stores.filter(
          (store) => store.code !== selectedStoreDetail?.code
        );

        this.stores.set([selectedStoreDetail, ...filteredStores]);
        this.isLoadingStores.set(false);
      },
    });
  }

  submit(): boolean {
    return !this.isLoadingStores();
  }
}
